import { createAsyncThunk } from "@reduxjs/toolkit";

import API, { showNetworkErrorToast } from "Utils/api";
import { DataStatus } from "../../types";

export const fetchGetCompanies = createAsyncThunk(
  "companies/fetchGetCompanies",
  async () => {
    try {
      const response = await API.get("companies/");

      return response.data.results;
    } catch (error) {
      showNetworkErrorToast(error);
      return Promise.reject();
    }
  }
);

/**
 * Names for the companies the session may see (DEV-5516).
 *
 * The `custom:company_ids` claim carries UUIDs only, so without this the nav bar renders
 * raw UUIDs on every page that does not already list companies. It calls the same endpoint
 * as `fetchGetCompanies`, which cloud-core scopes to the caller's companies, so nothing is
 * exposed that the session could not already read.
 *
 * Two differences from `fetchGetCompanies`: it runs at most once per session (it tracks its
 * own `sessionStatus`, so it neither marks the list loaded for the pages that gate on
 * `getIsCompaniesLoaded` nor touches the error state one of them is showing), and a failure
 * is silent — the picker keeps its UUID fallback rather than putting a network toast in
 * front of a user who did not ask for companies.
 */
export const fetchSessionCompanies = createAsyncThunk(
  "companies/fetchSessionCompanies",
  async () => {
    const response = await API.get("companies/");

    return response.data.results;
  },
  {
    condition: (_arg, { getState }) => {
      const { companies } = getState() as {
        companies: { sessionStatus: DataStatus };
      };
      return (
        companies.sessionStatus !== DataStatus.loading &&
        companies.sessionStatus !== DataStatus.succeeded
      );
    },
  }
);
